import React from 'react';
import ComingSoon from 'components/ComingSoon/ComingSoon';

const Chart = () => {
  return (
    <ComingSoon className="bg-white rounded-[1rem] shadow-primary h-full" />
  );
};

export default Chart;
